export default "__VITE_ASSET__pfQ8KtTo__"